export const AUDITOR_SUMMARY_COMPANY_ID = 76677
export const AUDITOR_SUMMARY_TEMPLATE_ID = 170584
export const AUDITOR_SUMMARY_DEFAULT_TARGET = 90
export const AUDITOR_SUMMARY_ROUTE = '/auditor-summary'
export const AUDITOR_SUMMARY_PATH = '/app/auditor-summary'

export const getUserCompanyId = user =>
    Number(
        user?.CompanyId ?? user?.Companies?.[0]?.CompanyId ?? 0,
    )

export const canViewAuditorSummary = user =>
    getUserCompanyId(user) === AUDITOR_SUMMARY_COMPANY_ID
